import useOnPlayPause from './useOnPlayPause'
import useOnPause from './useOnPause'
import useOnPlay from './useOnPlay'
import useRateBtns from './useRateBtns'
import usePlugins from './usePlugins'
import useOnMount from './useOnMount'
import useDownload from './useDownload'
import useAudioEffects from './useAudioEffects'

export default { useAudioEffects, useDownload, useOnMount, useOnPlayPause, usePlugins, useOnPause, useOnPlay, useRateBtns }